// app-user · Bookings tab, booking detail + its sheets, Notifications — strings the design
// handoff chrome set (app-strings.ts, `app.bookings.*` / `app.notifications.*`) does not
// carry: parameterised copy for real data (the demo copy there names a doctor, a salon…),
// states, a11y names, toasts and the notification-kind titles. Spread into en.ts / bn.ts.
export const appEnBookings = {
  // list
  'app.bookings.ui.searchA11y': 'Search bookings',
  'app.bookings.ui.searchPh': 'Business, service or booking code',
  'app.bookings.ui.noMatchT': 'No matches',
  'app.bookings.ui.noMatchB': 'Try a different name or booking code.',
  'app.bookings.ui.gateT': 'Sign in to see your bookings',
  'app.bookings.ui.gateB': 'Your bookings, passes and receipts live on your account.',
  'app.bookings.ui.gateCta': 'Sign in',
  'app.bookings.ui.errT': 'Couldn’t load your bookings',
  'app.bookings.ui.errB': 'Something went wrong on our side. Try again in a moment.',
  'app.bookings.ui.offlineAgo': 'Offline, last updated {ago}',
  'app.bookings.ui.offlineNow': 'Offline, last updated a moment ago',
  'app.bookings.ui.offlineNoCache': 'You’re offline. Connect to see your bookings.',
  'app.bookings.ui.moreErr': 'Couldn’t load the rest of your bookings.',
  'app.bookings.ui.offlineNotSavedT': 'Not saved for offline',
  'app.bookings.ui.offlineNotSavedB': 'Only your next upcoming bookings are kept on this phone. Connect to see these.',
  'app.bookings.ui.offlineMore': '{n, plural, one{# more booking isn’t} other{# more bookings aren’t}} saved for offline. Connect to see them.',
  'app.bookings.ui.cardA11y': '{biz}, {status}, {when}',
  'app.bookings.ui.groupCount': '{n} {label}',
  'app.bookings.ui.nights': '{n, plural, one{# night} other{# nights}}',
  'app.bookings.ui.openFailed': 'Couldn’t open that on this phone.',
  'app.bookings.ui.searchClose': 'Close search',
  'app.bookings.ui.tabA11y': '{label}, {n, plural, one{# booking} other{# bookings}}',
  'app.bookings.ui.refreshFailed': 'Couldn’t refresh. Showing what we have.',
  'app.bookings.ui.callNoPhone': 'This business has no phone number on file.',
  'app.bookings.ui.noLocation': 'This business has no address on file.',
  'app.bookings.ui.share': 'Share booking',
  'app.bookings.ui.close': 'Close',
  // detail
  'app.bookings.ui.progress': 'Progress',
  'app.bookings.ui.directions': 'Directions',
  'app.bookings.ui.qrA11y': 'Booking QR code, {code}',
  'app.bookings.ui.copyTrx': 'Copy TrxID',
  'app.bookings.ui.trxCopied': 'TrxID copied',
  'app.bookings.ui.pasteTrx': 'Paste TrxID',
  'app.bookings.ui.toBookings': 'Go to my bookings',
  'app.bookings.ui.loadErrT': 'Couldn’t load this booking',
  'app.bookings.ui.notFoundT': 'Booking not found',
  'app.bookings.ui.notFoundB': 'It may have been removed, or it belongs to another account.',
  'app.bookings.ui.shareMsg': '{biz} · {when} · {code}',
  'app.bookings.ui.qrNote': 'Show this code at the desk when you arrive.',
  'app.bookings.ui.qrUsed': 'Used on {date}.',
  'app.bookings.ui.qrUsedPlain': 'This pass has been used.',
  'app.bookings.ui.feePaid': '{amount} · Paid',
  'app.bookings.ui.fSeats': 'Seats',
  'app.bookings.ui.fServices': 'Services',
  'app.bookings.ui.fNotes': 'Notes',
  'app.bookings.ui.fMoved': 'Rescheduled',
  'app.bookings.ui.fMovedValue': 'From {from} to {to}',
  'app.bookings.ui.yes': 'Yes',
  'app.bookings.ui.no': 'No',
  'app.bookings.ui.sendProof': 'Send payment proof',
  'app.bookings.ui.shotA11y': 'View payment screenshot',
  'app.bookings.ui.shotLoadErr': 'Couldn’t open the screenshot. Try again.',
  'app.bookings.ui.addCalendar': 'Add to calendar',
  'app.bookings.ui.calendarDone': 'Calendar file ready',
  'app.bookings.ui.calendarErr': 'Couldn’t prepare the calendar file. Try again.',
  'app.bookings.ui.receiptDone': 'Receipt ready',
  'app.bookings.ui.receiptErr': 'Couldn’t prepare the receipt. Try again.',
  'app.bookings.ui.shareUnavailable': 'Sharing isn’t available on this device.',
  'app.bookings.ui.offlineAction': 'You’re offline. Reconnect to do this.',
  'app.bookings.ui.actionErr': 'Something went wrong. Try again.',
  'app.bookings.ui.expiredBody': 'This booking expired before payment arrived. You can book it again.',
  // states (extra statuses with no design message)
  'app.bookings.states.mInProgress': 'Show your pass when you arrive.',
  'app.bookings.states.mNoShow': 'You didn’t show up, so this visit was marked as a no-show.',
  'app.bookings.states.mSendProof': 'Send your payment proof to hold this booking.',
  // cancel sheet
  'app.bookings.cancelUi.sub': '{biz} · {when}',
  'app.bookings.cancelUi.refundLabelPaid': 'Refund request',
  'app.bookings.cancelUi.refundLabelNone': 'Nothing to refund',
  'app.bookings.cancelUi.refundWhenPaid': 'Your advance goes to the business’s refund queue',
  'app.bookings.cancelUi.refundWhenNone': 'No advance was paid for this booking',
  'app.bookings.cancelUi.refundBodyPaid': 'We’ll ask the business to return your {amount}. {policy}',
  'app.bookings.cancelUi.refundBodyNone': 'You haven’t paid anything yet, so cancelling costs you nothing.',
  'app.bookings.cancelUi.done': 'Booking cancelled',
  'app.bookings.cancelUi.doneRefund': 'Booking cancelled. Refund requested.',
  'app.bookings.cancelUi.conflict': 'This booking can’t be cancelled any more.',
  // reschedule sheet
  'app.bookings.reschedUi.sub': '{biz} · now {when}',
  'app.bookings.reschedUi.pickTime': 'Pick a new time',
  'app.bookings.reschedUi.noSlots': 'No free times on this day. Try another date.',
  'app.bookings.reschedUi.slotsErr': 'Couldn’t load free times.',
  'app.bookings.reschedUi.leftN': '{n} left',
  'app.bookings.reschedUi.full': 'Full',
  'app.bookings.reschedUi.serialsLeft': '{n, plural, one{# serial left} other{# serials left}}',
  'app.bookings.reschedUi.bookedOf': '{booked} of {cap} booked',
  'app.bookings.reschedUi.ctaDate': 'Change to {when}',
  'app.bookings.reschedUi.ctaSerial': 'Change to {when} · Serial {serial}',
  'app.bookings.reschedUi.ctaIdle': 'Pick a new time',
  'app.bookings.reschedUi.taken': 'That time was just taken. Pick another.',
  'app.bookings.reschedUi.approval': 'The business will confirm the new time.',
  'app.bookings.reschedUi.applied': 'Booking rescheduled. The business is told.',
  'app.bookings.reschedUi.note': 'Applies right away. The business is told.',
  // resubmit / first proof sheet
  'app.bookings.proofUi.titleFirst': 'Send payment proof',
  'app.bookings.proofUi.subFirst': '{biz} · {when}',
  'app.bookings.proofUi.reasonFallback': 'The business couldn’t match your payment.',
  'app.bookings.proofUi.trxLabel': 'TrxID',
  'app.bookings.proofUi.trxPh': 'e.g. BKA7X92MT4',
  'app.bookings.proofUi.hintGeneric': 'Letters and numbers, from the payment SMS.',
  'app.bookings.proofUi.camera': 'Camera',
  'app.bookings.proofUi.gallery': 'Gallery',
  'app.bookings.proofUi.shotAdded': 'Screenshot added',
  'app.bookings.proofUi.shotRemove': 'Remove screenshot',
  'app.bookings.proofUi.permission': 'Allow camera access in Settings to take a photo.',
  'app.bookings.proofUi.sent': 'Proof sent. The business will check it.',
  'app.bookings.proofUi.needOne': 'Add the TrxID or a screenshot to continue.',
  // report sheet
  'app.bookings.reportUi.sub': '{biz} · {when} · {code}',
  'app.bookings.reportUi.photoRemove': 'Remove photo',
  'app.bookings.reportUi.conflict': 'You already have an open report on this booking.',
  'app.bookings.reportUi.caseTitle': 'Report',
  'app.bookings.reportUi.openCase': 'Open report',
  'app.bookings.reportUi.closedCase': 'Report decided',
  // notification rows
  'app.bookings.notif.viewBooking': 'View booking',
  'app.bookings.notif.viewCase': 'View report',
  'app.bookings.notif.viewReview': 'Open reviews',
  'app.bookings.notif.viewMessage': 'Open message',
  'app.bookings.notif.unreadN': '{n} unread',
  'app.bookings.notif.offlineB': 'You’re offline. Connect to see your notifications.',
  'app.bookings.notif.errT': 'Couldn’t load notifications',
  'app.bookings.notif.errB': 'Something went wrong on our side. Try again in a moment.',
  'app.bookings.notif.emptyT': 'All caught up',
  'app.bookings.notif.emptyB': 'Nothing needs you right now.',
  'app.bookings.notif.gateT': 'Sign in to see your notifications',
  'app.bookings.notif.markFailed': 'Couldn’t mark them read. Try again.',
  'app.bookings.notif.titleGeneric': 'Update',
  'app.bookings.notif.kindBookingPlaced': 'Booking placed',
  'app.bookings.notif.kindBookingConfirmed': 'Booking confirmed',
  'app.bookings.notif.kindProofSubmitted': 'Proof received',
  'app.bookings.notif.kindProofVerified': 'Proof accepted',
  'app.bookings.notif.kindProofRejected': 'Payment proof didn’t match',
  'app.bookings.notif.kindReviewRequest': 'How was your visit?',
  'app.bookings.notif.kindReminder': 'Coming up soon',
  'app.bookings.notif.kindCancelled': 'Booking cancelled',
  'app.bookings.notif.kindRescheduled': 'Booking rescheduled',
  'app.bookings.notif.kindRefund': 'Refund update',
  'app.bookings.notif.kindDispute': 'Update on your report',
  'app.bookings.notif.kindReviewReply': 'Reply to your review',
  'app.bookings.notif.unreadA11y': 'Unread',
} as const satisfies Record<string, string>;

export const appBnBookings = {
  'app.bookings.ui.searchA11y': 'বুকিং খুঁজুন',
  'app.bookings.ui.searchPh': 'ব্যবসা, সার্ভিস বা বুকিং কোড',
  'app.bookings.ui.noMatchT': 'কিছু মেলেনি',
  'app.bookings.ui.noMatchB': 'অন্য নাম বা বুকিং কোড দিয়ে চেষ্টা করুন।',
  'app.bookings.ui.gateT': 'বুকিং দেখতে সাইন ইন করুন',
  'app.bookings.ui.gateB': 'আপনার বুকিং, পাস ও রসিদ আপনার অ্যাকাউন্টে থাকে।',
  'app.bookings.ui.gateCta': 'সাইন ইন',
  'app.bookings.ui.errT': 'আপনার বুকিং লোড হয়নি',
  'app.bookings.ui.errB': 'আমাদের দিকে সমস্যা হয়েছে। একটু পরে আবার চেষ্টা করুন।',
  'app.bookings.ui.offlineAgo': 'অফলাইন, সর্বশেষ আপডেট {ago}',
  'app.bookings.ui.offlineNow': 'অফলাইন, এইমাত্র আপডেট হয়েছে',
  'app.bookings.ui.offlineNoCache': 'আপনি অফলাইনে। বুকিং দেখতে ইন্টারনেটে যুক্ত হোন।',
  'app.bookings.ui.moreErr': 'বাকি বুকিং লোড হয়নি।',
  'app.bookings.ui.offlineNotSavedT': 'অফলাইনে সেভ করা নেই',
  'app.bookings.ui.offlineNotSavedB': 'এই ফোনে শুধু সামনের বুকিংগুলো রাখা থাকে। এগুলো দেখতে ইন্টারনেটে যুক্ত হোন।',
  'app.bookings.ui.offlineMore': 'আরও {n}টি বুকিং অফলাইনে সেভ করা নেই। দেখতে ইন্টারনেটে যুক্ত হোন।',
  'app.bookings.ui.cardA11y': '{biz}, {status}, {when}',
  'app.bookings.ui.groupCount': '{n} {label}',
  'app.bookings.ui.nights': '{n} রাত',
  'app.bookings.ui.openFailed': 'এই ফোনে এটি খোলা যায়নি।',
  'app.bookings.ui.searchClose': 'খোঁজা বন্ধ করুন',
  'app.bookings.ui.tabA11y': '{label}, {n}টি বুকিং',
  'app.bookings.ui.refreshFailed': 'রিফ্রেশ হয়নি। যা আছে তা দেখানো হচ্ছে।',
  'app.bookings.ui.callNoPhone': 'এই ব্যবসার কোনো ফোন নম্বর নেই।',
  'app.bookings.ui.noLocation': 'এই ব্যবসার কোনো ঠিকানা নেই।',
  'app.bookings.ui.share': 'বুকিং শেয়ার করুন',
  'app.bookings.ui.close': 'বন্ধ করুন',
  'app.bookings.ui.progress': 'অগ্রগতি',
  'app.bookings.ui.directions': 'দিকনির্দেশ',
  'app.bookings.ui.qrA11y': 'বুকিং কিউআর কোড, {code}',
  'app.bookings.ui.copyTrx': 'TrxID কপি করুন',
  'app.bookings.ui.trxCopied': 'TrxID কপি হয়েছে',
  'app.bookings.ui.pasteTrx': 'TrxID পেস্ট করুন',
  'app.bookings.ui.toBookings': 'আমার বুকিংয়ে যান',
  'app.bookings.ui.loadErrT': 'এই বুকিং লোড হয়নি',
  'app.bookings.ui.notFoundT': 'বুকিং পাওয়া যায়নি',
  'app.bookings.ui.notFoundB': 'এটি সরানো হয়ে থাকতে পারে, অথবা অন্য অ্যাকাউন্টের।',
  'app.bookings.ui.shareMsg': '{biz} · {when} · {code}',
  'app.bookings.ui.qrNote': 'পৌঁছে ডেস্কে এই কোড দেখান।',
  'app.bookings.ui.qrUsed': '{date} ব্যবহৃত।',
  'app.bookings.ui.qrUsedPlain': 'এই পাস ব্যবহৃত হয়েছে।',
  'app.bookings.ui.feePaid': '{amount} · দেওয়া',
  'app.bookings.ui.fSeats': 'আসন',
  'app.bookings.ui.fServices': 'সার্ভিস',
  'app.bookings.ui.fNotes': 'নোট',
  'app.bookings.ui.fMoved': 'সময় বদল',
  'app.bookings.ui.fMovedValue': '{from} থেকে {to}',
  'app.bookings.ui.yes': 'হ্যাঁ',
  'app.bookings.ui.no': 'না',
  'app.bookings.ui.sendProof': 'পেমেন্ট প্রুফ পাঠান',
  'app.bookings.ui.shotA11y': 'পেমেন্ট স্ক্রিনশট দেখুন',
  'app.bookings.ui.shotLoadErr': 'স্ক্রিনশট খোলা যায়নি। আবার চেষ্টা করুন।',
  'app.bookings.ui.addCalendar': 'ক্যালেন্ডারে যোগ করুন',
  'app.bookings.ui.calendarDone': 'ক্যালেন্ডার ফাইল তৈরি',
  'app.bookings.ui.calendarErr': 'ক্যালেন্ডার ফাইল তৈরি হয়নি। আবার চেষ্টা করুন।',
  'app.bookings.ui.receiptDone': 'রসিদ তৈরি',
  'app.bookings.ui.receiptErr': 'রসিদ তৈরি হয়নি। আবার চেষ্টা করুন।',
  'app.bookings.ui.shareUnavailable': 'এই ডিভাইসে শেয়ার করা যাচ্ছে না।',
  'app.bookings.ui.offlineAction': 'আপনি অফলাইনে। এটি করতে ইন্টারনেটে যুক্ত হোন।',
  'app.bookings.ui.actionErr': 'কিছু ভুল হয়েছে। আবার চেষ্টা করুন।',
  'app.bookings.ui.expiredBody': 'পেমেন্ট আসার আগেই এই বুকিংয়ের মেয়াদ শেষ হয়েছে। আবার বুক করতে পারেন।',
  'app.bookings.states.mInProgress': 'পৌঁছে আপনার পাস দেখান।',
  'app.bookings.states.mNoShow': 'আপনি উপস্থিত হননি, তাই এই ভিজিট অনুপস্থিত হিসেবে চিহ্নিত।',
  'app.bookings.states.mSendProof': 'বুকিং ধরে রাখতে পেমেন্ট প্রুফ পাঠান।',
  'app.bookings.cancelUi.sub': '{biz} · {when}',
  'app.bookings.cancelUi.refundLabelPaid': 'ফেরতের অনুরোধ',
  'app.bookings.cancelUi.refundLabelNone': 'ফেরত দেওয়ার কিছু নেই',
  'app.bookings.cancelUi.refundWhenPaid': 'আপনার অগ্রিম ব্যবসার ফেরত তালিকায় যাবে',
  'app.bookings.cancelUi.refundWhenNone': 'এই বুকিংয়ে কোনো অগ্রিম দেওয়া হয়নি',
  'app.bookings.cancelUi.refundBodyPaid': 'ব্যবসাকে আপনার {amount} ফেরত দিতে বলা হবে। {policy}',
  'app.bookings.cancelUi.refundBodyNone': 'আপনি এখনো কিছু দেননি, তাই বাতিল করতে কোনো খরচ নেই।',
  'app.bookings.cancelUi.done': 'বুকিং বাতিল হয়েছে',
  'app.bookings.cancelUi.doneRefund': 'বুকিং বাতিল হয়েছে। ফেরতের অনুরোধ পাঠানো হয়েছে।',
  'app.bookings.cancelUi.conflict': 'এই বুকিং আর বাতিল করা যাবে না।',
  'app.bookings.reschedUi.sub': '{biz} · এখন {when}',
  'app.bookings.reschedUi.pickTime': 'নতুন সময় বেছে নিন',
  'app.bookings.reschedUi.noSlots': 'এই দিনে কোনো সময় খালি নেই। অন্য তারিখ দেখুন।',
  'app.bookings.reschedUi.slotsErr': 'খালি সময় লোড হয়নি।',
  'app.bookings.reschedUi.leftN': '{n}টি বাকি',
  'app.bookings.reschedUi.full': 'পূর্ণ',
  'app.bookings.reschedUi.serialsLeft': '{n}টি সিরিয়াল বাকি',
  'app.bookings.reschedUi.bookedOf': '{cap}-এর {booked}টি বুক হয়েছে',
  'app.bookings.reschedUi.ctaDate': '{when}-এ বদলান',
  'app.bookings.reschedUi.ctaSerial': '{when} · সিরিয়াল {serial}-এ বদলান',
  'app.bookings.reschedUi.ctaIdle': 'নতুন সময় বেছে নিন',
  'app.bookings.reschedUi.taken': 'ওই সময়টি এইমাত্র নেওয়া হয়ে গেছে। অন্যটি বেছে নিন।',
  'app.bookings.reschedUi.approval': 'ব্যবসা নতুন সময় নিশ্চিত করবে।',
  'app.bookings.reschedUi.applied': 'বুকিংয়ের সময় বদলেছে। ব্যবসাকে জানানো হয়েছে।',
  'app.bookings.reschedUi.note': 'সাথে সাথে কার্যকর। ব্যবসাকে জানানো হয়।',
  'app.bookings.proofUi.titleFirst': 'পেমেন্ট প্রুফ পাঠান',
  'app.bookings.proofUi.subFirst': '{biz} · {when}',
  'app.bookings.proofUi.reasonFallback': 'ব্যবসা আপনার পেমেন্ট মেলাতে পারেনি।',
  'app.bookings.proofUi.trxLabel': 'TrxID',
  'app.bookings.proofUi.trxPh': 'যেমন BKA7X92MT4',
  'app.bookings.proofUi.hintGeneric': 'পেমেন্ট এসএমএস থেকে অক্ষর ও সংখ্যা।',
  'app.bookings.proofUi.camera': 'ক্যামেরা',
  'app.bookings.proofUi.gallery': 'গ্যালারি',
  'app.bookings.proofUi.shotAdded': 'স্ক্রিনশট যোগ হয়েছে',
  'app.bookings.proofUi.shotRemove': 'স্ক্রিনশট সরান',
  'app.bookings.proofUi.permission': 'ছবি তুলতে সেটিংসে ক্যামেরার অনুমতি দিন।',
  'app.bookings.proofUi.sent': 'প্রুফ পাঠানো হয়েছে। ব্যবসা যাচাই করবে।',
  'app.bookings.proofUi.needOne': 'এগোতে TrxID বা স্ক্রিনশট দিন।',
  'app.bookings.reportUi.sub': '{biz} · {when} · {code}',
  'app.bookings.reportUi.photoRemove': 'ছবি সরান',
  'app.bookings.reportUi.conflict': 'এই বুকিংয়ে আপনার একটি রিপোর্ট আগে থেকেই খোলা আছে।',
  'app.bookings.reportUi.caseTitle': 'রিপোর্ট',
  'app.bookings.reportUi.openCase': 'রিপোর্ট খোলা',
  'app.bookings.reportUi.closedCase': 'রিপোর্টের সিদ্ধান্ত হয়েছে',
  'app.bookings.notif.viewBooking': 'বুকিং দেখুন',
  'app.bookings.notif.viewCase': 'রিপোর্ট দেখুন',
  'app.bookings.notif.viewReview': 'রিভিউ খুলুন',
  'app.bookings.notif.viewMessage': 'মেসেজ খুলুন',
  'app.bookings.notif.unreadN': '{n} অপঠিত',
  'app.bookings.notif.offlineB': 'আপনি অফলাইনে। নোটিফিকেশন দেখতে ইন্টারনেটে যুক্ত হোন।',
  'app.bookings.notif.errT': 'নোটিফিকেশন লোড হয়নি',
  'app.bookings.notif.errB': 'আমাদের দিকে সমস্যা হয়েছে। একটু পরে আবার চেষ্টা করুন।',
  'app.bookings.notif.emptyT': 'সব দেখা হয়ে গেছে',
  'app.bookings.notif.emptyB': 'এখন আপনার জন্য কিছু নেই।',
  'app.bookings.notif.gateT': 'নোটিফিকেশন দেখতে সাইন ইন করুন',
  'app.bookings.notif.markFailed': 'পঠিত করা যায়নি। আবার চেষ্টা করুন।',
  'app.bookings.notif.titleGeneric': 'আপডেট',
  'app.bookings.notif.kindBookingPlaced': 'বুকিং হয়েছে',
  'app.bookings.notif.kindBookingConfirmed': 'বুকিং নিশ্চিত',
  'app.bookings.notif.kindProofSubmitted': 'প্রুফ পাওয়া গেছে',
  'app.bookings.notif.kindProofVerified': 'প্রুফ গৃহীত',
  'app.bookings.notif.kindProofRejected': 'পেমেন্ট প্রুফ মেলেনি',
  'app.bookings.notif.kindReviewRequest': 'ভিজিট কেমন ছিল?',
  'app.bookings.notif.kindReminder': 'শীঘ্রই আসছে',
  'app.bookings.notif.kindCancelled': 'বুকিং বাতিল',
  'app.bookings.notif.kindRescheduled': 'বুকিং-এর সময় বদলেছে',
  'app.bookings.notif.kindRefund': 'ফেরতের আপডেট',
  'app.bookings.notif.kindDispute': 'আপনার রিপোর্টের আপডেট',
  'app.bookings.notif.kindReviewReply': 'আপনার রিভিউর উত্তর',
  'app.bookings.notif.unreadA11y': 'অপঠিত',
} as const satisfies Record<keyof typeof appEnBookings, string>;
